import React from "react";
import ReactTimeout from "react-timeout";
import { r } from "../utils";
import { compose, lifecycle, withState } from "recompose";
import { HideMobile, ShowMobile } from "./blocks/Responsive";
import Waypoint from "react-waypoint";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { getFontFamily } from "../utils";
import { P, H3 } from "./typography";
import AspectImage from "./atoms/AspectImage";
import Flex from "../components/blocks/Flex";
import Spacer from "../components/blocks/Spacer";

const Quote = H3.extend`
  display: flex;
  justify-content: center;
  line-height: 1.5;
  padding: 1rem;
  padding-top: 2rem;
  text-align: center;
  ${getFontFamily};
  font-size: 2.5rem;
  font-weight: 600;
  transition: opacity 500ms;

  ${props => props.theme.media.mobile`
    font-size: 2rem;
  `};
`;

const ChoiceSlider = styled.div`
  padding-top: 10vh;
  left: 0;
  right: 0;
  opacity: ${({ stage }) => (stage < 0 ? 0 : 1)};
  transform: translateY(${({ stage }) => (stage < 2 ? 0 : "3vh")});
  transition: opacity 500ms, transform 500ms;
  height: 48rem;
  ${props => props.theme.media.mobile`
    font-size: 2rem;
  `};
`;

const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DescriptionGrid = Grid.extend`
  opacity: ${({ stage }) => (stage < 2 ? 0 : 1)};
  transition-delay: opacity 1500ms;
  transition: transform 500ms, opacity 500ms;
  padding-top: 3rem;
  @media (max-width: 960px) {
    padding-top: 1rem;
    padding-bottom: 1.5rem;
  }
`;

const QuoteWrapper = styled.div`
  transform: ${({ stage }) =>
    stage > 1 ? "translateY(4rem)" : "translateY(-10rem)"};
  opacity: ${({ stage }) => (stage > 0 ? "1" : "0")};
  transition: opacity 500ms, transform 500ms;
  animation: anim 0.7s 1 ease;
`;

const Block = styled.div`
  transform: ${({ index, stage }) => {
    return {
      0: "translateY(4rem)",
      1: "translateY(4rem)",
      2: "translateY(8rem)",
      3: "translateY(8rem)"
    }[stage];
  }};
  transition: transform 500ms;
  width: 14rem;
  padding: 0 1rem;
  height: 12rem;
  display: flex;
  justify: center;
  align: flex - start;
  img {
    width: 100%;
  }
  @media (max-width: 960px) {
    width: 8rem;
    height: 7rem;
    padding-bottom: 1.5rem;
  }
`;

const BlockDescription = P.extend`@media (max-width: 960px) {font-size: 1rem;}`;

const Method = styled.div`
  flex: 1;
  ${r("padding", "1.5rem", "2rem 25vw")};
`;

const StageWaypoint = ({ stage, onStageChange, position }) =>
  <Waypoint
    onPositionChange={({ currentPosition, previousPosition }) => {
      if (currentPosition === "inside" && previousPosition === "above")
        onStageChange(stage);
      if (currentPosition === "above") onStageChange(stage + 1);
    }}
  >
    <div
      className={"stage-" + stage}
      style={{ position: "absolute", top: position }}
    />
  </Waypoint>;

const MissionTracks = styled.div`position: relative;`;

const MissionAnimation = ({
  quote,
  src,
  stage,
  onStageChange,
  descriptions = [""]
}) =>
  <MissionTracks>
    <StageWaypoint stage={1} position="10px" onStageChange={onStageChange} />
    <ChoiceSlider stage={stage}>
      <Grid stage={stage}>
        {src.map(src =>
          <Block stage={stage}>
            <img src={src.responsiveResolution.src} />
          </Block>
        )}
      </Grid>
      <Flex direction="column">
        <Flex justify="center" align="flex-start">
          <DescriptionGrid stage={stage} pad>
            {descriptions.map(text => {
              return (
                <Block stage={stage} active={2}>
                  <BlockDescription align="center" style={{ width: "100%" }}>
                    <ReactMarkdown source={text} />
                  </BlockDescription>
                </Block>
              );
            })}
          </DescriptionGrid>
        </Flex>
        <QuoteWrapper stage={stage}>
          <Quote serif align="center">
            <ReactMarkdown source={quote} />
          </Quote>
        </QuoteWrapper>
      </Flex>
      <Grid stage={stage} />
    </ChoiceSlider>
  </MissionTracks>;

const HeroMission = ({
  quote = "",
  descriptions = [""],
  src = {},
  stage = -1,
  onStageChange,
  ...props
}) => {
  return (
    <div>
      <ShowMobile>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingTop: "4rem"
          }}
        >
          <Flex direction="column" align="stretch">
            {src.map(({ responsiveResolution, description }, index) =>
              <Method>
                <AspectImage
                  aspect={1}
                  src={responsiveResolution.src}
                  key={index}
                />
                <P align="center" style={{ paddingTop: "1rem" }}>
                  {description}
                </P>
              </Method>
            )}
          </Flex>
          <Spacer span={8} />
          <Quote serif stage={stage} align={"center"}>
            <ReactMarkdown source={quote} />
          </Quote>
        </div>
      </ShowMobile>
      <HideMobile>
        <MissionAnimation
          quote={quote}
          src={src}
          stage={stage}
          onStageChange={onStageChange}
          descriptions={descriptions}
        />
      </HideMobile>
    </div>
  );
};

export default compose(
  ReactTimeout,
  withState("stage", "onStageChange", -1),
  lifecycle({
    componentWillMount() {
      this.props.setTimeout(() => {
        this.props.onStageChange(0);
        this.props.setTimeout(() => {
          this.props.onStageChange(1);
        }, 500);
      }, 500);
    }
  })
)(HeroMission);



// WEBPACK FOOTER //
// ./src/components/HeroMission.js